import { AppColors } from "@/assets/colors";
import { pxToRem } from "@/util";
import { investData } from "@/util/types";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { makeStyles } from "tss-react/mui";

export default function InvestReason({
  mainImg,
  reasons,
}: Partial<investData>) {
  const { classes } = styles();

  return (
    <Box className={`${classes.container}`}>
      <Box className={classes.imgCont}>
        <Image
          src={mainImg || "/images/home/contractor.svg"}
          alt="contractor"
          //layout="responsive"
          fill
          style={{ objectFit: "contain", objectPosition: "top" }}
        />
      </Box>

      <Box className={` ${classes.det}`}>
        {reasons &&
          reasons.map((data, index) => (
            <Box key={index} className={`${classes.card}`}>
              <Box className={classes.cardImg}>
                <Image
                  src={`/images/home/${data.img}`}
                  fill
                  style={{ objectFit: "cover" }}
                  alt="contractor"
                />
              </Box>
              <Box className={classes.desc}>
                <Typography className={classes.deschead}>
                  {data.head}
                </Typography>
                <Typography className={classes.descdet}>{data.desc}</Typography>
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    paddingTop: theme.spacing(2),
    height: pxToRem(658),
    gap: pxToRem(24),
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "auto",
      gap: theme.spacing(4),
    },
  },
  imgCont: {
    flex: 1,
    position: "relative",
    display: "flex",
    borderRadius: pxToRem(8),
    overflow: "hidden",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    minHeight: pxToRem(300),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minHeight: pxToRem(400),
      marginTop: theme.spacing(4),
      // border: "1px solid red",
    },
  },

  det: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    justifyContent: "space-between",
  },
  desc: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    flex: 1,
  },
  debug: {
    border: "1px solid red",
  },
  card: {
    height: pxToRem(166),
    borderRadius: pxToRem(8),
    border: `1px solid ${AppColors.neutral["70"]}`,
    display: "flex",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      height: "auto",
      gap: theme.spacing(2),
    },
  },
  cardImg: {
    position: "relative",
    width: pxToRem(68),
    height: pxToRem(68),
    [theme.breakpoints.down("sm")]: {
      width: pxToRem(52),
      height: pxToRem(52),
    },
  },
  deschead: {
    fontSize: pxToRem(20),
    fontWeight: 600,
    fontFamily: "General sans",
    lineHeight: "160%",
  },
  descdet: {
    color: AppColors.text.second,
    fontWeight: 500,
    fontSize: pxToRem(16),
    width: "60%",
    [theme.breakpoints.down(1360)]: {
      width: "100%",
      fontSize: pxToRem(15),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(15),
    },
  },
}));
